import { isGlobalConnectFinland } from '../utils/communication-operator.util';

export const navigationUrls = {
  swedish: {
    defaultRedirect: 'beställ/tjänster/utbud',
    supply: 'utbud',
    confirmRelative: './bekräfta',
    confirm: 'bekräfta',
    addressSearchFull: 'beställ/tjänster/adressök',
    addressSearch: 'adressök',
    order: 'beställ',
    fiberInterestFull: 'beställ/fiber/intresseanmälan',
    leisureHomes: 'fritidshus',
    services: 'tjänster',
    thankYou: 'tack',
    productDetails: 'produkt-detaljer',
  },
  finnish: {
    defaultRedirect: 'tilaa/palvelut/tarjonta',
    supply: 'tarjonta',
    confirmRelative: './vahvista',
    confirm: 'vahvista',
    addressSearchFull: 'tilaa/palvelut/osoitehaku',
    addressSearch: 'osoitehaku',
    order: 'tilaa',
    services: 'palvelut',
    thankYou: 'Kiitos',
    productDetails: 'tuotetiedot',
  },
};

export const getNavigationUrl = () => {
  return isGlobalConnectFinland()
    ? navigationUrls.finnish
    : navigationUrls.swedish;
};
